import { ISelect } from './types'
import './styles.scss'

export const Select = ({
  optionsList,
  defaultValue,
  label,
  name,
  wrapperClassName,
  className,
  onChange,
  error,
  ...props
}: ISelect) => {
  return (
    <div
      className={`dropdownContainer ${
        wrapperClassName ? wrapperClassName : ''
      } ${error ? 'selectError' : ''}`}
    >
      {label && (
        <label className="labelForSelect" htmlFor={name}>
          {label}
        </label>
      )}

      <select
        style={{
          width: props.width ? props.width : props.fullscreen ? '100%' : 500,
          height: props.height ?? 48,
        }}
        className={`selectContainer ${className ? className : ''}`}
        id={name}
        onChange={onChange}
        {...props}
      >
        <option value="">{defaultValue}</option>
        {optionsList.map((option) => {
          return (
            <option key={`dropdown-${option.value}`} value={option.value}>
              {option.name}
            </option>
          )
        })}
      </select>

      {error && <span className="error">{error}</span>}
    </div>
  )
}
